import React from "react";
import { accountTier } from "../lib/accountTier";

/**
 * Wraps a friend avatar with a tier-colored ring + a small corner pip so you can
 * tell Kid / Teen / Grown-up accounts apart at a glance. Keep it subtle in lists.
 * Usage: <TierRing friend={friend} size={44}><FriendFace .../></TierRing>
 */
export function TierRing({ friend, size = 44, children, testId }) {
  const t = accountTier(friend);
  return (
    <span className="relative inline-flex flex-shrink-0" style={{ width: size, height: size }} data-testid={testId || `tier-ring-${t.tier}`}>
      <span className="absolute inset-0 rounded-full ring-2" style={{ boxShadow: `0 0 0 2px ${t.ring}` }} />
      <span className="absolute inset-[2px] rounded-full overflow-hidden">{children}</span>
      <span aria-hidden className="absolute -bottom-0.5 -right-0.5 text-[11px] leading-none rounded-full bg-slate-900 border border-white/20 w-[17px] h-[17px] flex items-center justify-center" title={t.label}>{t.pip}</span>
    </span>
  );
}

/** Small text chip used on the friend PROFILE (accessible label, not color-only). */
export function TierChip({ friend, testId }) {
  const t = accountTier(friend);
  return (
    <span data-testid={testId || `tier-chip-${t.tier}`}
      className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-extrabold"
      style={{ background: t.bg, border: `1px solid ${t.border}`, color: t.color }}>
      <span aria-hidden>{t.pip}</span> {t.chip}
    </span>
  );
}

export default TierRing;
